



















import {Vue, Component, Prop} from 'vue-property-decorator';

@Component

export default class Types extends Vue{

  @Prop() ['classPrefix']: string
  @Prop({required: true}) titleName!: string
  goBack(){
    this.$router.back()
  }
}
